module.exports = __webpack_public_path__ + "img/northernlights.a6eaf60f.svg";